import React from "react";
import { aiccVocabularyApi } from "services/aiccLearningAssets";
import { LessonEntryAssetConfig } from "types/model/aiccLearningAssets";
import LessonEntryPage from "../LessonEntries";

const VOCABULARY_CONFIG: LessonEntryAssetConfig = {
  title: "Vocabulary",
  textLabel: "Vocabulary",
  addText: "+ Add Vocabulary",
  exportName: "vocabulary",
  fieldGuideIntro:
    "This list consolidates the vocabulary acquired in this lesson. They are added to learner’s personalized bank " +
    "to tailor future practice to your learning habits.",
  hasAgenticAssetLink: true,
  api: aiccVocabularyApi,
};

function VocabularyManagement() {
  return <LessonEntryPage config={VOCABULARY_CONFIG} />;
}

export default VocabularyManagement;
